import { getStoredPreferredLanguage } from "shared-core/services/i18n.ts";
import { getPublicAgentDownloadUrl } from "shared-ui/composables/use-public-agent-download-url.ts";

const LEGACY_AGENT_DOWNLOAD_PATHS = new Set([
  "/app/download",
  "/agent/download",
]);

/**
 * The download page moved to the public site, so the old in-app paths
 * have to bounce there.
 * @param pathname - The path to check, without query or hash.
 * @returns The URL to redirect to, or null when this isn't a legacy path.
 */
export function resolveLegacyAgentDownloadRedirect(
  pathname: string,
): string | null {
  const normalizedPath = pathname.replace(/\/+$/, "");
  if (!LEGACY_AGENT_DOWNLOAD_PATHS.has(normalizedPath)) return null;

  return getPublicAgentDownloadUrl(getStoredPreferredLanguage() ?? "en");
}

/**
 * Sends the browser to the public site.
 * @param url - The absolute URL to replace the current one with.
 */
export function leaveForPublicSite(url: string): void {
  window.location.replace(url);
}
